module.exports = __webpack_public_path__ + "img/stat_map_en_mobile.ae5743cf.png";